export const SHORTCUT_KEYS = [
  {
    id: 1,
    label: 'NAVIGATE_DROPDOWN',
    firstKey: 'Up',
    secondKey: 'Down',
    keySet: ['ArrowUp', 'ArrowDown'],
  },
  {
    id: 2,
    label: 'RESOLVE_CONVERSATION',
    firstKey: 'Alt / ⌥',
    secondKey: 'E',
    keySet: ['Alt+KeyE'],
  },
  {
    id: 3,
    label: 'GO_TO_CONVERSATION_DASHBOARD',
    firstKey: 'Alt / ⌥',
    secondKey: 'C',
    keySet: ['Alt+KeyC'],
  },
  {
    id: 4,
    label: 'ADD_ATTACHMENT',
    firstKey: 'Alt / ⌥',
    secondKey: 'A',
    keySet: ['Alt+KeyA'],
  },
  {
    id: 5,
    label: 'GO_TO_CONTACTS_DASHBOARD',
    firstKey: 'Alt / ⌥',
    secondKey: 'V',
    keySet: ['Alt+KeyV'],
  },
  {
    id: 6,
    label: 'TOGGLE_SIDEBAR',
    firstKey: 'Alt / ⌥',
    secondKey: 'O',
    keySet: ['Alt+KeyO'],
  },
  {
    id: 7,
    label: 'GO_TO_REPORTS_SIDEBAR',
    firstKey: 'Alt / ⌥',
    secondKey: 'R',
    keySet: ['Alt+KeyR'],
  },
  {
    id: 8,
    label: 'MOVE_TO_NEXT_TAB',
    firstKey: 'Alt / ⌥',
    secondKey: 'N',
    keySet: ['Alt+KeyN'],
  },
  {
    id: 9,
    label: 'GO_TO_SETTINGS',
    firstKey: 'Alt / ⌥',
    secondKey: 'S',
    keySet: ['Alt+KeyS'],
  },
  {
    id: 11,
    label: 'SWITCH_TO_PRIVATE_NOTE',
    firstKey: 'Alt / ⌥',
    secondKey: 'P',
    keySet: ['Alt+KeyP'],
  },
  {
    id: 12,
    label: 'SWITCH_TO_REPLY',
    firstKey: 'Alt / ⌥',
    secondKey: 'L',
    keySet: ['Alt+KeyL'],
  },
  {
    id: 13,
    label: 'TOGGLE_SNOOZE_DROPDOWN',
    firstKey: 'Alt / ⌥',
    secondKey: 'M',
    keySet: ['Alt+KeyM'],
  },
];
